<main class="container-fluid h-100 p-0">
  <app-toast-message [justAfterLogin]="false"></app-toast-message>
  <section id="register" class="row justify-content-center d-flex align-items-center h-100"
    aria-label="Registration section">


    <section class="col-7 col-md-7 col-lg-5 col-xl-4 login-container">


      <section class="row logo login--heading login--heading__register">
        <div class="col-12">
          <h1 aria-level="1" class="float-left">Reset Password</h1>
          <img src="assets/images/logo.svg#logo" alt="Learningmate - Frost align" class="float-right" />
        </div>
      </section>

      <section class="row p-0">
        <div class="form-group col-12">
          <label for="emailInputId" tabindex="-1">Work email</label>
          <input #emailInput type="text" class="form-control" name="emailInputId" id="emailInputId"
            aria-label="Your existing email id" [formControl]="form.controls['email']" [(ngModel)]="email"
            [attr.disabled]="true">
        </div>

        <div class="form-group col-12 my-0">
          <label for="password">New Password</label>
          <input type="password" [(ngModel)]="passwordEnt" (keyup)="repasswordEntered($event.target.value)"
            class="form-control" name="password" id="password" placeholder="" [formControl]="form.controls['password']"
            required aria-label="Please enter your new password">

          <div *ngIf="form.controls['password'].touched && form.controls['password'].hasError('minlength')"
            class="error--txt" role="alert">
            <p class="font-bold m-0 d-flex align-items-center mt-1">
              <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
              Password must be minimum of 8 characters
            </p>
          </div>

          <div *ngIf="form.controls['password'].touched && form.controls['password'].hasError('pattern')"
            class="error--txt" role="alert">
            <p class="font-bold m-0 d-flex align-items-center mt-1">
              <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
              Password must contain a mixture of uppercase and lowercase letters, numbers and symbols
            </p>
          </div>

        </div>

        <div class="form-group col-12 mt-2">
          <label for="confirmPassword">Confirm Password</label>
          <input type="password" [(ngModel)]="repasswordEnt" (keyup)="repasswordEntered($event.target.value)"
            class="form-control" name="confirmPassword" id="confirmPassword" placeholder=""
            [formControl]="form.controls['cpassword']" required aria-label="Please confirm your password">

          <div *ngIf="form.controls['cpassword'].hasError('required') && form.controls['cpassword'].touched "
            class="error--txt" role="alert">
            <p class="font-bold m-0 d-flex align-items-center mt-1">
              <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
              You must include confirm password
            </p>
          </div>
          <div class="error--txt" *ngIf="form.controls['cpassword'].touched && !match" role="alert">
            <p class="font-bold m-0 d-flex align-items-center mt-1">
              <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
              Passwords do not match
            </p>
          </div>

        </div>
      </section>
      <section class="row align-items-center login--btn-set">
        <div class="col">
          <button aria-label="Reset Password" class="btn btn-primary btn__login" (click)="onResetPassword()"
            [disabled]="!form.valid || !match">Reset Password</button>
        </div>
        <div class="col text-right"></div>
      </section>
    </section>
  </section>
</main>